import { MasterListPage } from "@/pages/admin/MasterListPage";
import { Landmark } from "lucide-react";

export default function AdminKoperasi() {
  return (
    <MasterListPage
      title="Koperasi"
      kicker="Master Data"
      description="Daftar baku koperasi tempat pegawai terdaftar. Dipakai sebagai pilihan dropdown di profil pegawai."
      icon={Landmark}
      endpoint="/master/koperasi"
      testPrefix="koperasi"
      addLabel="Tambah Koperasi"
      emptyLabel="Belum ada Koperasi. Klik tombol di atas untuk menambahkan."
      namaPlaceholder="Contoh: Koperasi Karyawan Sucofindo EPISI"
      kodePlaceholder="Contoh: KKS"
    />
  );
}
